import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../../api/api";

const MmseLink = () => {
  const { patientid, filename } = useParams();
  const [loading, setLoading] = useState(true);
  const [json, setJson] = useState(null);

  const practiseid = window.getPracticeId();
  const SCREENSHOT_TARGET_ID = "screenshot-ready-container";

  useEffect(() => {
    const fetchHtml = async () => {
      try {
        const response = await api.get(
          `/v1/${practiseid}/pcard/${patientid}/formHistory/${filename}`
        );
        if (response.status === 200) setJson(response.data?.json_data || null);
      } catch (err) {
        console.log(err);
      } finally {
        setTimeout(() => setLoading(false), 300);
      }
    };

    fetchHtml();
  }, [filename]);

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen text-xl font-semibold">
        Loading...
      </div>
    );

  if (!json)
    return (
      <div className="flex items-center justify-center h-screen text-xl text-red-600">
        No Data Found
      </div>
    );

  // ------------------------------------------------------------------------------------------------

  const questions = [
    { q: "What is the year? Season? Date? Day of the week? Month?", key: "qanswer_2_2" },
    { q: "Where are we now: State? County? Town/City? Hospital? Floor?", key: "qanswer_2_3" },
    { q: "Name three unrelated objects. Number of trials:", key: "qanswer_2_4" },
    { q: "Count backward from 100 by sevens OR spell WORLD backwards.", key: "qanswer_2_5" },
    { q: "Recall the three earlier named objects.", key: "qanswer_2_6" },
    { q: "Name two simple objects (e.g., pencil, watch).", key: "qanswer_2_7" },
    { q: "Repeat the phrase: 'No ifs, ands, or buts.'", key: "qanswer_2_8" },
    { q: "Follow 3-step command: take paper, fold it, put on floor.", key: "qanswer_2_9" },
    { q: "Read and do: ‘Close your eyes’", key: "qanswer_2_10" },
    { q: "Write a sentence containing a noun and a verb.", key: "qanswer_2_11" },
    { q: "Copy the drawing with intersecting shapes.", key: "qanswer_2_12" },
  ];

  const scores = [1, 2, 3, 4, 5];

  // ------------------------------------------------------------------------------------------------

  return (
    <>
    

      <div id={json.patient_name?SCREENSHOT_TARGET_ID:undefined} className="min-h-screen bg-[#f7f7f7] flex justify-center py-10 px-3">
        <div className="bg-white text-start shadow-lg rounded-lg p-6 max-w-4xl w-full">

          {/* Header */}
          <h2 className="text-2xl font-bold mb-4">{json.form_name}</h2>

          {/* Instructions */}
          <div className="mb-4">
            <p className="font-bold mb-1">Instructions:</p>
            <p className="text-gray-700">
              Ask questions in order. Score one point for each correct response within each section.
            </p>
          </div>

          {/* Patient Info */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div>
              <label className="font-bold text-base">Patient Name</label>
              <p>{json.patient_name}</p>
            </div>
            <div>
              <label className="font-bold text-base">Date</label>
              <p>{json.cdate}</p>
            </div>
          </div>

          {/* Questions */}
          {questions.map((q, idx) => (
            <div key={idx} className="mb-6">
              <label className="font-bold text-base">{q.q}</label>
              <div className="flex flex-wrap gap-2 mt-2">
                {scores.map((val, i) => (
                  <div key={val} className="flex flex-col items-center">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-sans border ${
                        Number(json[q.key]) === val
                          ? "bg-blue-600 text-white border-blue-600"
                          : "bg-white border-gray-300 text-black"
                      }`}
                    >
                      {val}
                    </span>

                    {/* Min/Max labels */}
                    {i === 0 && (
                      <span className="text-xs text-gray-500 mt-1">Min</span>
                    )}
                    {i === scores.length - 1 && (
                      <span className="text-xs text-gray-500 mt-1">Max</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Total Score */}
          <div className="mt-6 p-4 bg-gray-100 border-l-4 border-blue-600 rounded-md text-gray-800">
            <p className="font-semibold">Total Score:</p>
            <p className="text-lg font-bold">{json.total_score}</p>
          </div>

        </div>
      </div>
    </>
  );
};

export default MmseLink;
